import {insert, isNil, sortBy} from 'ramda';

import {ChartVariant} from '../types/ChartVariant';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';

export const sortStatisticsCarsForChart = (
  cars: ExtendedStatisticsCar[],
  chartVariant: ChartVariant
): ExtendedStatisticsCar[] => {
  if (chartVariant === 'priceMap' || chartVariant === 'mapView') {
    return cars;
  }

  const myVehicle = cars.find((car) => car.isMyVehicle);
  const competitors = cars.filter((car) => !car.isMyVehicle);
  const sortedCompetitors = sortBy((car) => car.original_price_with_vat, competitors);

  const carsWithMyVehicle = isNil(myVehicle)
    ? sortedCompetitors
    : (() => {
        const myVehiclePrice = myVehicle.original_price_with_vat;
        const insertIndex = sortedCompetitors.findIndex(
          (car) => car.original_price_with_vat > myVehiclePrice
        );

        return insert(
          insertIndex === -1 ? sortedCompetitors.length : insertIndex,
          myVehicle,
          sortedCompetitors
        );
      })();

  return carsWithMyVehicle.map((car, index) => ({
    ...car,
    position: index + 1,
  }));
};
